module.exports = __webpack_public_path__ + "static/img/pbrand9.e944e585.png";